import graphqlClient from '../../../services/graphqlClient';
import {isNil, pick} from 'ramda';
import getPartnersQuery from '../graphql/getPartnersQuery';
import createPartnerMutation from '../graphql/createPartnerMutation';
import deletePartnerMutation from '../graphql/deletePartnerMutation';
import updatePartnerMutation from '../graphql/updatePartnerMutation';
import {
  addToPartners,
  deleteFromPartners,
  partnersFetchFailed,
  partnersFetchStarted,
  partnersFetchSucceeded,
  resetPartner,
  updatePartners
} from './slice';

export const getPartners = (queryParams, force = false) => {
  return (dispatch, getState) => {
    const {partners} = getState();
    const {partnersLoading, list} = partners;

    // Only fetch if not already loading and no partners are present
    if (!force && (partnersLoading || Array.isArray(list))) return;

    dispatch(partnersFetchStarted());

    graphqlClient
      .query({
        query: getPartnersQuery,
        variables: {...queryParams}
      })
      .then(result => {
        const {
          data: {busPartners}
        } = result;

        dispatch(partnersFetchSucceeded(busPartners));
      })
      .catch(err => {
        console.error(err);
        dispatch(partnersFetchFailed());
      });
  };
};

export const savePartner = callback => {
  return (dispatch, _getState) => {
    const state = _getState();
    const partner = {...state.partners.partner};

    partner.depots = partner.depots.map(depot =>
      pick(['city', 'street', 'postCode'], depot)
    );

    const isCreating = isNil(partner.id);
    const mutation = isCreating ? createPartnerMutation : updatePartnerMutation;

    const variables = {
      name: partner.name,
      mobilityPartnerId: partner.mobilityPartnerId,
      countryId: partner.countryId,
      depots: partner.depots
    };
    if (!isCreating) {
      variables.id = partner.id;
    }

    const successCallback = isCreating ? addToPartners : updatePartners;

    graphqlClient
      .mutate({mutation, variables, errorPolicy: 'all'})
      .then(result => {
        const {errors} = result;
        if (errors) {
          const errorMessage =
            errors[0]?.extensions?.errorMessage || errors[0].message;
          console.error(errorMessage);
        } else {
          const dataKey = Object.keys(result.data)[0];
          const updatedData = result.data[dataKey];
          dispatch(successCallback(updatedData));
          dispatch(resetPartner());
          if (callback) callback(updatedData);
        }
      });
  };
};

export const deletePartner = (partner, addToast) => {
  return dispatch => {
    graphqlClient
      .mutate({
        mutation: deletePartnerMutation,
        variables: pick(['id'], partner),
        errorPolicy: 'all'
      })
      .then(result => {
        const {
          data: {deleteBusPartner},
          errors
        } = result;
        if (errors) {
          addToast({
            type: 'danger',
            content: errors[0]?.extensions?.errorMessage || errors[0].message
          });
        } else {
          addToast({
            type: 'success',
            content: `Partner ${partner.name} deleted successfully`
          });
          dispatch(deleteFromPartners(deleteBusPartner));
        }
      });
  };
};
